var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdvPlpExternalRegister',{ref:"registerExternal",attrs:{"customer":_vm.customer}})
}
var staticRenderFns = []

export { render, staticRenderFns }